module.exports = __webpack_public_path__ + "website/img/successfulDetail_4_13.c002dc54.jpg";